<template>
  <div class="varinhas-page">
    <div class="varinhas-box">
      <div class="varinhas-header">
        <h1 class="varinhas-title">Varinhas de treino</h1>
        <p class="varinhas-subtitle">Compare se é melhor comprar na Store com coins ou vender RC e comprar no NPC com gold</p>
      </div>
      <div class="varinhas-body">
        <div class="varinhas-input-section">
          <label class="varinhas-label">Quanto está o coin no seu servidor?</label>
          <div class="varinhas-input-wrap">
            <input
              v-model.number="goldPerRc"
              type="number"
              min="0"
              step="100"
              class="varinhas-input"
              placeholder="Ex: 45000"
            />
          </div>
        </div>

        <div v-if="goldPerRc > 0" class="varinhas-table-wrap">
          <table class="varinhas-table">
            <thead>
              <tr>
                <th>Arma</th>
                <th>Cargas</th>
                <th>Store</th>
                <th>NPC</th>
                <th>Custo equivalente (loja)</th>
                <th>Recomendação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="w in weapons" :key="w.id" :class="['varinhas-row', { 'varinhas-row-best': isBestCostBenefit(w) }]">
                <td>
                  <div class="varinhas-cell-weapon">
                    <img :src="w.image" :alt="w.name" class="varinhas-img" />
                    <span>{{ w.name }}</span>
                    <span v-if="isBestCostBenefit(w)" class="varinhas-badge">Melhor custo-benefício</span>
                  </div>
                </td>
                <td>{{ w.charges.toLocaleString("pt-BR") }}</td>
                <td>{{ w.storeRc }} RC</td>
                <td>{{ formatGp(w.npcGp) }}</td>
                <td>{{ formatGp(storeEquivalentGp(w)) }}</td>
                <td>
                  <span :class="recommendationClass(w)">{{ recommendation(w) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else class="varinhas-empty">
          <p>Informe o valor em gold por 1 RC acima para ver a comparação.</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const WEAPONS = [
  {
    id: "exercise",
    name: "Exercise Weapon",
    charges: 500,
    storeRc: 40,
    npcGp: 347222,
    image: "/img/exercise_durable.gif",
  },
  {
    id: "durable",
    name: "Durable Exercise Weapon",
    charges: 1800,
    storeRc: 80,
    npcGp: 1250000,
    image: "/img/exercise_durable.gif",
  },
  {
    id: "lasting",
    name: "Lasting Exercise Weapon",
    charges: 14400,
    storeRc: 190,
    npcGp: 10000000,
    image: "/img/exercise_lasting.gif",
  },
  {
    id: "daily",
    name: "Daily Exercise Weapon",
    charges: 45000,
    storeRc: 390,
    npcGp: 31250000,
    image: "/img/exercise_lasting.gif",
  },
];

export default {
  data() {
    return {
      goldPerRc: 45000,
      weapons: WEAPONS,
    };
  },
  computed: {
    bestCostBenefitId() {
      const price = Number(this.goldPerRc);
      if (!price || price <= 0) return null;
      let bestId = null;
      let bestCostPerCharge = Infinity;
      this.weapons.forEach((w) => {
        const storeEquiv = w.storeRc * price;
        const effectiveCost = Math.min(storeEquiv, w.npcGp);
        const costPerCharge = effectiveCost / w.charges;
        if (costPerCharge < bestCostPerCharge) {
          bestCostPerCharge = costPerCharge;
          bestId = w.id;
        }
      });
      return bestId;
    },
  },
  methods: {
    formatGp(value) {
      if (value == null || Number.isNaN(value)) return "—";
      return value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " gp";
    },
    storeEquivalentGp(weapon) {
      const price = Number(this.goldPerRc);
      if (!price || price <= 0) return null;
      return weapon.storeRc * price;
    },
    recommendation(weapon) {
      if (weapon.id === "daily") return "Vendida apenas na loja com coins (não disponível no NPC)";
      const equiv = this.storeEquivalentGp(weapon);
      if (equiv == null) return "—";
      return equiv > weapon.npcGp ? "Melhor no NPC com gold" : "Melhor na loja com coins";
    },
    recommendationClass(weapon) {
      if (weapon.id === "daily") return "varinhas-rec-store";
      const equiv = this.storeEquivalentGp(weapon);
      if (equiv == null) return "";
      return equiv > weapon.npcGp ? "varinhas-rec-npc" : "varinhas-rec-store";
    },
    isBestCostBenefit(weapon) {
      return this.bestCostBenefitId === weapon.id;
    },
  },
};
</script>
<style scoped>
.varinhas-page {
  min-height: 60vh;
}

.varinhas-box {
  border: 2px solid #8b6914;
  border-radius: 8px;
  background: linear-gradient(180deg, #2a2520 0%, #1c1916 100%);
  overflow: hidden;
}

.varinhas-header {
  background: rgba(139, 105, 20, 0.25);
  border-bottom: 1px solid rgba(139, 105, 20, 0.5);
  padding: 1.25rem 1.5rem;
}

.varinhas-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 0.02em;
}

.varinhas-subtitle {
  margin: 0.35rem 0 0;
  font-size: 0.9rem;
  color: #8a7a5c;
}

.varinhas-body {
  padding: 1.5rem;
}

.varinhas-input-section {
  margin-bottom: 1.5rem;
}

.varinhas-label {
  display: block;
  font-size: 0.95rem;
  font-weight: 600;
  color: #c9b896;
  margin-bottom: 0.5rem;
}

.varinhas-input-wrap {
  display: flex;
  align-items: center;
  max-width: 280px;
}

.varinhas-input {
  flex: 1;
  padding: 0.6rem 0.9rem;
  font-size: 1rem;
  color: #e8dcc8;
  background: rgba(0, 0, 0, 0.35);
  border: 1px solid rgba(139, 105, 20, 0.5);
  border-radius: 6px;
}

.varinhas-input:focus {
  outline: none;
  border-color: #8b6914;
}

.varinhas-table-wrap {
  overflow-x: auto;
}

.varinhas-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  color: #e8dcc8;
}

.varinhas-table th,
.varinhas-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid rgba(139, 105, 20, 0.3);
}

.varinhas-table th {
  font-weight: 600;
  color: #d4af37;
  background: rgba(0, 0, 0, 0.2);
}

.varinhas-table tbody tr:hover {
  background: rgba(0, 0, 0, 0.15);
}

.varinhas-cell-weapon {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.varinhas-badge {
  padding: 0.2rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 700;
  color: #1c1916;
  background: #d4af37;
  border-radius: 4px;
}

.varinhas-row-best {
  background: rgba(212, 175, 55, 0.12);
  border-left: 3px solid #d4af37;
}

.varinhas-img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.varinhas-rec-npc {
  color: #7cb87c;
  font-weight: 600;
}

.varinhas-rec-store {
  color: #d4af37;
  font-weight: 600;
}

.varinhas-empty {
  padding: 2rem;
  text-align: center;
  color: #8a7a5c;
  font-size: 0.95rem;
}

@media (max-width: 991px) {
  .varinhas-table {
    font-size: 0.8rem;
  }
  .varinhas-table th,
  .varinhas-table td {
    padding: 0.5rem 0.6rem;
  }
}
</style>
